import React from "react";
import "@Styles/mandate.css";
import { CircularProgressbarWithChildren } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const NewSignUp = () => {
  return (
    <>
      <div className="main_div">
        <div className="container">
          <div className="pb-4 upper-padding">
            <div className="circular-progress">
              <CircularProgressbarWithChildren value={66}>
                <div className="text-center inner-content">
                  <span>Available limit</span>
                  <br />
                  <span className="limit">
                    <sup>₹</sup>0
                  </span>
                  <br />
                  <button>APPLY NOW</button>
                </div>
              </CircularProgressbarWithChildren>
            </div>
            <div className="wrapper-content w-c-mt">
              <div className="card-height px-4 pb-3 pt-1 w-100 text-center mx-auto bg-gray rounded-40 shadow-lg">
                <div className="d-flex flex-column justify-content-between">
                  <div className="pt-4 pb-5">
                    <button className="black-btn pdt">INCREASE LIMIT</button>
                    <br />
                    <h1>
                      “Financial
                      <br />
                      Happiness”
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewSignUp;
